import { BaseButton, Row, SizedBox } from "../CommonBaseComponents";
import CustomIcon from "../image/CustomIcon";
import { C4Text } from "../text/CustomText";
import { Theme } from "../../Theme";

function SecondaryButton({
    icon,
    text,
    onClick,
    fontColor = Theme.color.zinc850,
    width = "auto",
    padding,
    ref,
    disabled = false,
}) {
    return (
        <BaseButton
            width={width}
            padding={padding ?? (icon ? "8.5px 10px" : "10px 10px")}
            border={`1px solid ${Theme.color.gray250}`}
            borderRadius={"8px"}
            backgroundColor={Theme.color.white}
            onClick={onClick}
            hoverBackgroundColor={Theme.color.neutral100}
            ref={ref}
            disabled={disabled}
        >
            <Row alignItem={"center"} cursor={"pointer"}>
                {icon && (
                    <>
                        <CustomIcon iconName={icon} size={"17px"} cursor={"pointer"} />
                        <SizedBox width={"7px"} />
                    </>
                )}
                <C4Text fontColor={fontColor}>{text}</C4Text>
            </Row>
        </BaseButton>
    );
}

export default SecondaryButton;
